import React from "react";
import store from "../store";

import * as EnvironmentUtils from "./util/EnvironmentUtils";
import * as Utils from "./util/Utils";
import * as AnalyticsUtils from "./util/AnalyticsUtils";
import * as NavigationUtils from "./util/NavigationUtils";
import * as GlobalActions from "../store/Global/Global.action";

// There is an issue that prevents the page from refreshing when this is enabled.
// We use workbox for our service worker this needs investigation.
const ENABLE_SERVICE_WORKER = false && EnvironmentUtils.isProduction();

/**
 * document.onload
 *
 * @returns {Promise<void>}
 */
export const pageLoad = (): void => {
	NavigationUtils.initPreloader();
	EnvironmentUtils.refreshVersion();
};

Utils.forcePassiveListeners();

/**
 * Very start page init
 *
 * @returns {Promise<void>}
 */
export const pageInit = async (): Promise<void> => {
	AnalyticsUtils.initialise();
	// Track initial page view
	AnalyticsUtils.trackPage();

	store.dispatch(GlobalActions.loadData());

	if ("serviceWorker" in navigator && ENABLE_SERVICE_WORKER) {
		window.addEventListener("load", () => {
			navigator.serviceWorker
				.register("/service-worker.js")
				.then((registration) => {
					//console.log('SW registered: ', registration);
					return registration;
				})
				.catch((registrationError) => {
					//console.log('SW registration failed: ', registrationError);
				});
		});
	}
};
